export default __webpack_public_path__ + "static/media/feature1-2.b71c2c5b.png";